<ui-input-select-wrapper [open]="open()" [theme]="theme()" (openChange)="open.set($event)">
    <ui-input-wrapper
        #wrapper
        [value]="selectedLabel()?.label"
        [placeholder]="placeholder()"
        [disabled]="isDisabled()"
        [label]="label()"
        [error]="error()"
        [errorMsg]="errorMsg()"
        [wrapValue]="wrapValue()"
        [theme]="theme()"
        [focussed]="open()"
        [attr.aria-expanded]="open()"
        [attr.aria-describedby]="error() && errorMsg() ? wrapper.errorId : null"
        [attr.aria-label]="ariaLabel() ?? label()"
        (clicked)="!isDisabled() ? openSelect() : open.set(false)"
        (keydown.enter)="!isDisabled() ? openSelect() : open.set(false)"
        tabindex="0"
        role="combobox"
    >
        <i
            class="icon-chevron-down text-accent transition-transform"
            [ngClass]="{
                'rotate-180': open(),
                'text-accent': theme() === 'light' || theme() === 'dark',
                'text-white': theme() === 'medium',
                'opacity-50': isDisabled(),
            }"
            aria-hidden="true"
            trailing
        ></i>
    </ui-input-wrapper>

    <div class="flex w-full flex-col" #listbox role="listbox" dropdown>
        @if (withNullSelect()) {
            <button
                class="flex items-center px-16 py-12 text-left transition-colors"
                [ngClass]="{ 'hover:bg-grey-200': theme() === 'light', 'hover:bg-blue': theme() === 'dark' }"
                [attr.aria-selected]="selected() === undefined"
                (click)="setValue(undefined)"
                role="option"
            >
                {{ nullSelectCustomLabel() }}
            </button>
        }

        @for (option of options(); let i = $index; track i) {
            <button
                class="0 flex items-center px-16 py-12 text-left transition-colors"
                [ngClass]="{ 'hover:bg-grey-200': theme() === 'light', 'hover:bg-blue': theme() === 'dark' }"
                [innerHTML]="option.label"
                [attr.aria-selected]="selected() === option.value"
                (click)="setValue(option.value)"
                role="option"
            ></button>
        }
    </div>
</ui-input-select-wrapper>
